import React, { useState, useEffect } from 'react'; // Adicionado useState e useEffect
import { Row, Col, Button, Alert, Table, Spinner, Modal, Form, Card, Badge } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import { useUserContext } from '../../UserContext';
import CurrencyInput from 'react-currency-input-field';

const ColaboradoresTab = ({
  allFuncionarios,
  isLoadingFuncionarios,
  funcionarioMessage,
  setFuncionarioMessage,
  handleOpenFuncionarioModal,
  handleDeleteFuncionario,
  deletingFuncionario,
  handleOpenNovoLancamentoModal,
  // Props para o Modal de Funcionário
  showFuncionarioModal,
  handleCloseFuncionarioModal,
  isEditingFuncionario,
  newFuncionarioData, // Mantido para valor, mas o handler será local
  // handleSaveFuncionario,
  creatingFuncionario,
  selectedSetorModal,
  setSelectedSetorModal,
  setores,
  cargosDoSetorModal,
  isLoadingCargosModal,
  especialidades, 
  setNewFuncionarioData, // Adicionado para limpar o cargo_id ao mudar setor
  handleSaveFuncionario: originalHandleSave, // Renomeia a prop para uso interno
  perfis // <<=== Adicionar prop para receber a lista de perfis
}) => {
  const { currentUserRole } = useUserContext();


  // Define o nome do setor "Corpo Clínico" que você quer usar como regra
  const NOME_SETOR_CORPO_CLINICO = 'Corpo Clínico'; // <<== AJUSTE SE O NOME FOR DIFERENTE
  // Define o nome do perfil "Médico" (StandardRole)
  const NOME_PERFIL_MEDICO = 'Médico'; // <<== AJUSTE SE O NOME FOR DIFERENTE

  // Encontra o objeto do perfil "Médico" para uso nos filtros e lógica
  const perfilMedico = (perfis || []).find(perfil => perfil.tipo === 'padrao' && perfil.nome === NOME_PERFIL_MEDICO);

  // Handler local para lidar com as mudanças nos inputs, incluindo as máscaras
  const handleLocalInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'telefoneCompleto') {
        const apenasNumeros = value.replace(/\D/g, '');
        const ddd = apenasNumeros.substring(0, 2);
        const celular = apenasNumeros.substring(2);

        // Atualiza o estado no componente pai com os campos separados
        setNewFuncionarioData(prev => ({ 
            ...prev, 
            telefoneCompleto: value, // para a máscara
            dddcelular: ddd,         // para o backend
            celular: celular         // para o backend
        }));
    } else {
        setNewFuncionarioData(prev => ({ ...prev, [name]: value }));
    }
  };

  // Handler específico para o campo de moeda (salário)
  const handleSalaryChange = (value, name, values) => {
    // CORREÇÃO: Usamos o `value` (string formatada, ex: "2.500,00") em vez de `values.float`.
    // Isso evita que a biblioteca reinterprete o valor numérico de forma incorreta (ex: 2500 como R$ 25,00).
    // A conversão para o formato numérico correto será feita apenas no momento de salvar.
    setNewFuncionarioData(prev => ({ ...prev, [name]: value || '' }));
  };

  // Wrapper para a função de salvar que garante a conversão do salário
  const handleSaveFuncionario = () => {
    const dataToSave = { ...newFuncionarioData };

    // O estado `newFuncionarioData.salario_base` já deve ser um número
    // graças ao `handleSalaryChange`. Esta verificação garante que, caso não seja,
    // ele será null ou um número válido, evitando enviar uma string formatada para a API.
    if (dataToSave.salario_base && typeof dataToSave.salario_base === 'string') {
      // 1. Remove o prefixo "R$ " e os pontos de milhar.
      const stringLimpa = dataToSave.salario_base.replace('R$ ', '').replace(/\./g, '');
      // 2. Substitui a vírgula decimal por um ponto.
      const stringNumerica = stringLimpa.replace(',', '.');
      // 3. Converte para um número de ponto flutuante.
      const valorFinal = parseFloat(stringNumerica);
      dataToSave.salario_base = !isNaN(valorFinal) ? valorFinal : null;
    } else {
      // Se já for um número (carregamento inicial) ou vazio, mantém como está ou define como nulo.
      dataToSave.salario_base = Number(dataToSave.salario_base) || null;
    }

    if (!dataToSave.tipo_contrato) {
      dataToSave.tipo_contrato = 'CLT';
    }    

    // Chama a função original de salvamento (do componente pai) com os dados corrigidos.
    originalHandleSave(dataToSave);
  };

  const handlePerfilChange = (e) => {
    const value = e.target.value;
    if (!value) {
      // Nenhum perfil selecionado
      setNewFuncionarioData(prev => ({ ...prev, entidade_perfil_id: null, standard_role_id: null }));
      return;
    }

    const [tipo, idStr] = value.split('|');
    const id = parseInt(idStr, 10);

    if (tipo === 'padrao') {
      setNewFuncionarioData(prev => ({ ...prev, standard_role_id: id, entidade_perfil_id: null }));
    } else if (tipo === 'customizado') {
      setNewFuncionarioData(prev => ({ ...prev, entidade_perfil_id: id, standard_role_id: null }));
    }
  };

    // Estado para controlar se o select de perfil está desabilitado
  const [isProfileSelectDisabled, setIsProfileSelectDisabled] = useState(false);

  // useEffect para aplicar a regra do "Corpo Clínico" -> "Médico"
  useEffect(() => {
    // Só executa a lógica se o modal estiver aberto
    // e se as listas de setores e perfis estiverem carregadas.
    if (showFuncionarioModal && setores.length > 0 && (perfis || []).length > 0) {
// selectedSetorModal é o ID do setor que está no estado newFuncionarioData.setor_id (ou similar)
      // ou o que foi selecionado no select do modal.
      
      // Use diretamente selectedSetorModal para encontrar o objeto do setor atual do dropdown
      const currentDropdownSectorId = selectedSetorModal;
      
// Encontra o objeto do setor. Converte para string para garantir comparação correta.
      const selectedSetorObj = setores.find(setor => setor.id?.toString() === currentDropdownSectorId?.toString());

      // Refined Guard: Only proceed if modal is open, lists are loaded, AND (if setorIdAtual is set, the corresponding object is found).
      if (!showFuncionarioModal || !(setores.length > 0) || !((perfis || []).length > 0) || (currentDropdownSectorId !== undefined && currentDropdownSectorId !== null && currentDropdownSectorId !== '' && !selectedSetorObj)) {
      // Mesmo pulando, precisamos garantir que o select de perfil esteja habilitado se não for Corpo Clínico
        setIsProfileSelectDisabled(false);
        return; 
      }
     
      // Se não encontrou o perfil Médico na lista, não continua a lógica de perfil.
      if (!perfilMedico) {
        console.warn("Perfil 'Médico' não encontrado na lista de perfis.");
        setIsProfileSelectDisabled(false); // Mantém habilitado se o perfil base não existe
        return;
      }

      if (selectedSetorObj && selectedSetorObj.nome === NOME_SETOR_CORPO_CLINICO) {
        // Log para confirmar que a condição do setor Corpo Clínico foi atendida

        // REGRA 2: Setor é "Corpo Clínico"

        // Mantém isProfileSelectDisabled para lógica de ocultação e para o useEffect saber o estado
        // Este estado controla a ocultação/exibição do select de perfil no JSX

        setIsProfileSelectDisabled(true);
        // Força o perfil "Médico" se ainda não estiver definido ou se for um perfil customizado
        if (newFuncionarioData.standard_role_id !== perfilMedico.id || newFuncionarioData.entidade_perfil_id !== null) {
          setNewFuncionarioData(prev => ({
            ...prev,
            standard_role_id: perfilMedico.id,
            entidade_perfil_id: null // Garante que o perfil customizado seja null
          }));
        }
      } else {
        // REGRA 1: Setor NÃO é "Corpo Clínico"
        // Log para confirmar que a condição do setor NÃO Corpo Clínico foi atendida

        // Este estado controla a ocultação/exibição do select de perfil no JSX
        setIsProfileSelectDisabled(false); // Habilita o select de perfil para outros setores
        // Se o perfil atual era "Médico" (porque o usuário mudou de setor), limpa-o.
        if (perfilMedico && (newFuncionarioData.standard_role_id === perfilMedico.id)) {
          setNewFuncionarioData(prev => ({
            ...prev,
            standard_role_id: null,
            entidade_perfil_id: null // Também limpa o perfil customizado por segurança
          }));
        }

      }
    }
  }, [selectedSetorModal, setores, perfis, setNewFuncionarioData, showFuncionarioModal, newFuncionarioData.standard_role_id, newFuncionarioData.entidade_perfil_id, NOME_SETOR_CORPO_CLINICO, NOME_PERFIL_MEDICO, isEditingFuncionario]); // Adicionado isEditingFuncionario para cobrir o estado inicial da edição

  // Logs para depuração no momento da renderização
  // const currentSelectedSetorObj = setores.find(setor => setor.id.toString() === selectedSetorModal);
  // const perfilMedicoParaRender = (perfis || []).find(p => p.tipo === 'padrao' && p.nome === 'Médico');

  
  return (
    <>
      <Card className="mb-4 bg-light border-0 shadow-sm">
        <Card.Body>
          <Card.Title as="h6">Dicas de Uso</Card.Title>
          <Card.Text as="div" className="small text-muted">
            <ul>
              <li><strong>Lançamentos:</strong> Use o botão 'Lançamentos' para registrar proventos (bônus, comissões) ou descontos (faltas, adiantamentos) na folha de pagamento de um colaborador.</li>
              <li><strong>Salário Base:</strong> O campo 'Salário Base', acessado ao criar ou editar um funcionário, é o valor fundamental usado como referência para gerar a folha de pagamento mensal.</li>
            </ul>
          </Card.Text>
        </Card.Body>
      </Card>
      <Row className="mt-3">
        <Col xs={12} md={6} className="mb-2 mb-md-0"> {/* Empilha em telas pequenas */}
          <h5>Funcionários</h5>
        </Col>
        <Col xs={12} md={6} className="text-xs-start text-md-end"> {/* Alinha botão à esquerda em telas pequenas, à direita em médias+ */}
          <Button variant="primary" onClick={() => handleOpenFuncionarioModal()}>
            Novo Funcionário
          </Button>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          {funcionarioMessage && <Alert variant={funcionarioMessage.type} onClose={() => setFuncionarioMessage(null)} dismissible>{funcionarioMessage.text}</Alert>}
          {isLoadingFuncionarios ? (
            <div className="text-center"><Spinner animation="border" /></div>
          ) : (
            <Table striped bordered hover responsive size="sm">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th className="d-none d-lg-table-cell">CPF</th>
                  <th className="d-none d-md-table-cell">Email</th>
                  <th>Setor</th>
                  <th className="d-none d-sm-table-cell">Cargo</th>
                  <th>Comissão</th>
                  <th className="text-center">Ações</th>
                </tr>
              </thead>
              <tbody>
                {allFuncionarios.map((funcionario) => (
                  <tr key={funcionario.id}>
                    <td>{funcionario.nome}</td>
                    <td className="d-none d-lg-table-cell">{funcionario.cpf}</td> {/* Oculta em telas menores que lg */}
                    <td className="d-none d-md-table-cell">{funcionario.email}</td> {/* Oculta em telas menores que md */}
                    <td>{funcionario.cargo?.setor?.nome || 'N/A'}</td>
                    <td className="d-none d-sm-table-cell">{funcionario.cargo?.nome || 'N/A'}</td> {/* Oculta em xs, mostra a partir de sm */}
                    <td className="text-center">
                      {funcionario.comissionavel ? (
                        <Badge bg="success">Sim</Badge>
                      ) : (
                        <Badge bg="secondary">Não</Badge>
                      )}
                    </td>
                    <td>
                      <Button variant="warning" size="sm" className="me-2" onClick={() => handleOpenFuncionarioModal(funcionario)}>
                        <span className="d-none d-md-inline">Editar</span>
                        <span className="d-inline d-md-none">E</span>
                      </Button>
                      <Button variant="danger" size="sm" onClick={() => handleDeleteFuncionario(funcionario.id)} disabled={deletingFuncionario}>
                        {deletingFuncionario ? <Spinner as="span" animation="border" size="sm" /> : 
                          <>
                            <span className="d-none d-md-inline">Excluir</span>
                            <span className="d-inline d-md-none">X</span>
                          </>
                        }
                      </Button>
                      <Button variant="info" size="sm" className="ms-2" onClick={() => handleOpenNovoLancamentoModal(funcionario)}>
                        <span className="d-none d-md-inline">Lançamentos</span>
                        <span className="d-inline d-md-none">L</span>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Col>
      </Row>

      {/* Modal para Criar/Editar Funcionário */}
      <Modal show={showFuncionarioModal} onHide={handleCloseFuncionarioModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{isEditingFuncionario ? 'Editar Funcionário' : 'Novo Funcionário'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {funcionarioMessage && <Alert variant={funcionarioMessage.type} onClose={() => setFuncionarioMessage(null)} dismissible>{funcionarioMessage.text}</Alert>}
          {/* CORREÇÃO: O onSubmit agora chama o wrapper local handleSaveFuncionario */}
          <Form onSubmit={(e) => { 
              e.preventDefault(); 
              handleSaveFuncionario(); 
          }}>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group controlId="selectedSetorModalTab" className="mb-3">
                  <Form.Label>Setor: *</Form.Label>
                  
                  <Form.Select 
                    value={selectedSetorModal} 
                    onChange={(e) => { 
                      setSelectedSetorModal(e.target.value); 
                      setNewFuncionarioData(prev => ({ ...prev, cargo_id: '' })); 
                    }} 
                    required
                  >
                    <option value="">Selecione um Setor</option>
                    {setores.map(setor => <option key={setor.id} value={setor.id}>{setor.nome}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group controlId="newFuncionarioCargoTab" className="mb-3">
                  <Form.Label>Cargo: *</Form.Label>
                  <Form.Select 
                    name="cargo_id" 
                    value={newFuncionarioData.cargo_id}
                    onChange={handleLocalInputChange}
                    required 
                    disabled={!selectedSetorModal || isLoadingCargosModal}
                  >
                    <option value="">{isLoadingCargosModal ? 'Carregando...' : (selectedSetorModal ? 'Selecione um Cargo' : 'Selecione um Setor primeiro')}</option>
                    {cargosDoSetorModal.map(cargo => <option key={cargo.id} value={cargo.id}>{cargo.nome}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group controlId="newFuncionarioTipoContratoTab" className="mb-3">
                  <Form.Label>Tipo de Contrato: *</Form.Label>
                  <Form.Select name="tipo_contrato" value={newFuncionarioData.tipo_contrato || 'CLT'} onChange={handleLocalInputChange} required>
                    <option value="">Selecione...</option>
                    <option value="CLT">CLT (Consolidação das Leis do Trabalho)</option>
                    <option value="PJ">PJ (Pessoa Jurídica)</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={8}>
                <Form.Group controlId="newFuncionarioNomeTab" className="mb-3">
                  <Form.Label>Nome Completo:</Form.Label>
                  <Form.Control type="text" name="nome" value={newFuncionarioData.nome} onChange={handleLocalInputChange} required />
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                {newFuncionarioData.cargo_id && especialidades.some(especialidade => especialidade.cargo_id === parseInt(newFuncionarioData.cargo_id)) && (
                  <Form.Group controlId="newFuncionarioEspecialidadeTab" className="mb-3">
                    <Form.Label>Especialidade:</Form.Label>
                    <Form.Select name="especialidade_id" value={newFuncionarioData.especialidade_id || ''} onChange={handleLocalInputChange} >
                      <option value="">Selecione</option>
                      {especialidades.filter(e => e.cargo_id === parseInt(newFuncionarioData.cargo_id)).map(e => (
                        <option key={e.id} value={e.id}>{e.nome}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={3}>
                <Form.Group controlId="newFuncionarioTelefoneTab" className="mb-3">
                  <Form.Label>Celular (com DDD): *</Form.Label>
                  <InputMask
                    mask="(99) 99999-9999"
                    // Se `telefoneCompleto` existir (após digitação), usa ele.
                    // Senão (ao carregar para edição), constrói o valor a partir de dddcelular e celular.
                    value={newFuncionarioData.telefoneCompleto !== undefined 
                      ? newFuncionarioData.telefoneCompleto 
                      : `${newFuncionarioData.dddcelular || ''}${newFuncionarioData.celular || ''}`}
                    onChange={handleLocalInputChange}
                    name="telefoneCompleto"
                  >
                    {(inputProps) => <Form.Control {...inputProps} type="tel" required />}
                  </InputMask>
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group controlId="newFuncionarioCpfTab" className="mb-3">
                  <Form.Label>CPF: *</Form.Label>
                  <InputMask
                    mask="999.999.999-99"
                    value={newFuncionarioData.cpf || ''}
                    onChange={handleLocalInputChange}
                    name="cpf"
                  >
                    {(inputProps) => <Form.Control {...inputProps} type="text" required />}
                  </InputMask>
                </Form.Group>
              </Col>
              <Col xs={12} md={5}>
                <Form.Group controlId="newFuncionarioEmailTab" className="mb-3">
                  <Form.Label>Email: *</Form.Label>
                  <Form.Control type="email" name="email" value={newFuncionarioData.email} onChange={handleLocalInputChange} required />
                </Form.Group>
              </Col>
            </Row>
            
            {/* Oculta o select de perfil se o setor for "Corpo Clínico" */}
            {!isProfileSelectDisabled && (
              <Row>
                
                <Col xs={12} md={6}>
                  <Form.Group controlId="newFuncionarioPerfilUnificadoTab" className="mb-3">
                    <Form.Label>Perfil de Acesso:</Form.Label>
                    <Form.Select
                      name="perfil_unificado_id" 
                      value={
                        newFuncionarioData.standard_role_id 
                          ? `padrao|${newFuncionarioData.standard_role_id}` 
                          : newFuncionarioData.entidade_perfil_id 
                            ? `customizado|${newFuncionarioData.entidade_perfil_id}` 
                            : ''
                      }
                      onChange={handlePerfilChange}
                    >
                      <option value="">
                        {isEditingFuncionario && !newFuncionarioData.entidade_perfil_id && !newFuncionarioData.standard_role_id ? 'Nenhum perfil vinculado' : 'Selecione um Perfil'}
                      </option>
                        {(perfis || []).filter(perfil => !(perfil.tipo === 'padrao' && perfil.key === 'representante_legal'))
                          .filter(perfil => {
                            const currentDropdownSectorObj = setores.find(s => s.id?.toString() === selectedSetorModal?.toString());
                            const isCorpoClinicoSelecionado = !!(currentDropdownSectorObj && currentDropdownSectorObj.nome === NOME_SETOR_CORPO_CLINICO);
                            if (perfil.tipo === 'padrao' && perfil.nome === NOME_PERFIL_MEDICO) {
                              return isCorpoClinicoSelecionado;
                            }
                            return true; 
                          })
                          .filter(perfil => !isProfileSelectDisabled || (perfilMedico && perfil.id === perfilMedico.id))
                          .map(perfil => <option key={`${perfil.tipo}-${perfil.id}`} value={`${perfil.tipo}|${perfil.id}`}>{perfil.nome} ({perfil.tipo === 'padrao' ? 'Padrão' : 'Customizado'})</option>)
                        }                  
                    </Form.Select>
                  </Form.Group>
                </Col>
                
              </Row>
            )}
            <Row>
              <Col xs={12} md={4}>
                <Form.Group controlId="newFuncionarioSalarioBaseTab" className="mb-3">
                  <Form.Label>Salário Base (R$):</Form.Label>
                  <CurrencyInput
                    id="newFuncionarioSalarioBaseTab"
                    name="salario_base"
                    className="form-control"
                    // A prop `value` do CurrencyInput espera um número ou uma string numérica.
                    // Convertendo para String garantimos consistência, e a biblioteca lida com a formatação.
                    // O importante é que o `onValueChange` salve o valor numérico no estado.
                    value={newFuncionarioData.salario_base?.toString() || ''}
                    onValueChange={handleSalaryChange}
                    placeholder="R$ 0,00"
                    allowDecimals={true}
                    decimalsLimit={2}
                    decimalSeparator=","
                    groupSeparator="."
                    prefix="R$ "
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={2} className="d-flex align-items-end pb-3">
                <Form.Group controlId="newFuncionarioComissionavelTab" className="mb-0">
                  <Form.Check 
                    type="switch"
                    id="comissionavel-switch"
                    label="Comissão Padrão"
                    name="comissionavel"
                    checked={newFuncionarioData.comissionavel || false}
                    onChange={(e) => setNewFuncionarioData(prev => ({ ...prev, comissionavel: e.target.checked }))}
                  />
                </Form.Group>
              </Col>
              {/* --- NOVO CAMPO PARA COMISSÃO ORIGINÁRIA --- */}
              <Col xs={12} md={3} className="d-flex align-items-end pb-3">
                <Form.Group controlId="newFuncionarioComissionavelOrigemTab" className="mb-0">
                  <Form.Check
                    type="switch"
                    id="comissionavel-origem-switch"
                    label="Comissão por Indicação"
                    name="comissionavel_origem"
                    checked={newFuncionarioData.comissionavel_origem || false}
                    onChange={(e) => setNewFuncionarioData(prev => ({ ...prev, comissionavel_origem: e.target.checked }))}
                  />
                </Form.Group>
              </Col>
              {/* NOVO CAMPO: Visível apenas para o Representante Legal */}
              {currentUserRole === 'Representante Legal' && (
                <Col xs={12} md={3} className="d-flex align-items-end pb-3">
                  <Form.Group controlId="newFuncionarioGerenteTab" className="mb-0">
                    <Form.Check 
                      type="switch"
                      id="gerente-switch"
                      label="Funcionário Gerente?"
                      name="is_gerente"
                      checked={newFuncionarioData.is_gerente || false}
                      onChange={(e) => setNewFuncionarioData(prev => ({ ...prev, is_gerente: e.target.checked }))}
                    />
                  </Form.Group>
                </Col>
              )}
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group controlId="newFuncionarioPasswordTab" className="mb-3">
                  <Form.Label>Senha:{isEditingFuncionario ? ' (Deixe em branco para não alterar)' : ' *'}</Form.Label>                  <Form.Control type="password" name="password" value={newFuncionarioData.password || ''} onChange={handleLocalInputChange} required={!isEditingFuncionario} minLength={isEditingFuncionario && !newFuncionarioData.password ? undefined : 8} />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group controlId="newFuncionarioPasswordConfirmationTab" className="mb-3">
                  <Form.Label>Confirmar Senha:{isEditingFuncionario ? '' : ' *'}</Form.Label>                  <Form.Control type="password" name="password_confirmation" value={newFuncionarioData.password_confirmation || ''} onChange={handleLocalInputChange} required={!isEditingFuncionario && !!newFuncionarioData.password} minLength={isEditingFuncionario && !newFuncionarioData.password_confirmation ? undefined : 8} />
                </Form.Group>
              </Col>
            </Row>
            <Button variant="secondary" onClick={handleCloseFuncionarioModal} className="me-2">Cancelar</Button>
            <Button variant="primary" type="submit" disabled={creatingFuncionario}>
              {creatingFuncionario ? <Spinner as="span" animation="border" size="sm" /> : (isEditingFuncionario ? 'Salvar Alterações' : 'Criar Funcionário')}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ColaboradoresTab;